export default "__VITE_ASSET__$KN6otzE__"